export const giftingConstants = {
    SET_GIFTING_FORM_DETAILS: 'SET_GIFTING_FORM_DETAILS'
}